import type { TemplateDraft as ITemplateDraft } from 'api/models';
import { TemplateId, TemplateObjectType } from 'data/templates/api';
import { DocumentTemplate } from 'data/templates/documents';
import { ProjectTemplateApi } from 'data/templates/projects';

export class TemplateDraft implements ITemplateDraft {
  content: ProjectTemplateApi | DocumentTemplate;

  timestamp: number;

  templateId: TemplateId;

  templateType: TemplateObjectType;

  constructor(resp: ITemplateDraft) {
    this.content = resp.content;
    this.timestamp = resp.timestamp;
    this.templateId = resp.templateId;
    this.templateType = resp.templateType;
  }
}
